module.exports = __webpack_public_path__ + "media/images/front/bnr_group-mb_side_dba-cebbb9b5b9acdb20f513aaf410917c7e.jpg";